import React from 'react';

import './prep-lessons__skeleton.scss';

const PromoThemeSkeleton = () => {
    return (
        <>
            <div className="prep-lessons__item prep-lessons__skeleton-item" />
            <div className="prep-lessons__item prep-lessons__skeleton-item" />
            <div className="prep-lessons__item prep-lessons__skeleton-item" />
        </>
    );
};

export default PromoThemeSkeleton;
